import React, {Component} from 'react';
//import logo from './logo.svg';
import AiLayout from './layout/AiLayout';
import 'font-awesome/css/font-awesome.css';
//import MediaQuery from 'react-responsive';
import {Messages} from 'primereact/components/messages/Messages';
import {Growl} from 'primereact/components/growl/Growl';
//import {Message} from 'primereact/components/message/Message';
import './ai_layout.css'
import 'primereact/resources/themes/omega/theme.css';
import 'primereact/resources/primereact.min.css';
import './App.css';
import ReactGA from 'react-ga4';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {
    JSON_URL,
    JSON_URL_PROD,
    DEFAULT_STATE_VALUE,
    MSG_NO_SKU
} from './constants';
import {
    header_footer_get_parameters
} from './header_footer_parameters';

//console.log('LOCATION',window.location)
//default value
header_footer_get_parameters('')


    if (window.currentEnv === 'www') 
          ReactGA.initialize('G-WNZ1RZDS0W'); 
     else 
            ReactGA.initialize('G-JW6XS1MPGX'); //guyal test
            
   ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Customizer" });
   //console.log('GA Test',ReactGA._currentMeasurementId) 
   console.log('Referrer',document.referrer) 

function processCfg(jsonIn) {
    var json = jsonIn
    var cfgDic = json.cfgdata
    if (cfgDic.hasOwnProperty('sku')) json['sku'] = cfgDic['sku']
    if (cfgDic.hasOwnProperty('s')) json['s'] = cfgDic['s']
    
    if (cfgDic.hasOwnProperty('t1')) json['e1'] = cfgDic['t1']
    if (cfgDic.hasOwnProperty('t2')) json['e2'] = cfgDic['t2']
    if (cfgDic.hasOwnProperty('t3')) json['e3'] = cfgDic['t3']
    if (cfgDic.hasOwnProperty('t4')) json['e4'] = cfgDic['t4']
    if (cfgDic.hasOwnProperty('t5')) json['e5'] = cfgDic['t5']
    if (cfgDic.hasOwnProperty('t6')) json['e6'] = cfgDic['t6']
    if (cfgDic.hasOwnProperty('t7')) json['e7'] = cfgDic['t7']
    if (cfgDic.hasOwnProperty('t8')) json['e8'] = cfgDic['t8']
    if (cfgDic.hasOwnProperty('chain')) json['chain'] = cfgDic['chain']
    if (cfgDic.hasOwnProperty('clist')) json['clist'] = cfgDic['clist']
    if (cfgDic.hasOwnProperty('g') && cfgDic['g'] !== null) {
        var gg= cfgDic['g'].split('&')
        var gg1 ;
        var gg2
        for (gg1 in gg) {
            gg2 =gg[gg1].split('=')
            json[gg2[0]] = gg2[1]
            if (gg2[0] ==='clist'){
                json['acust']='charm'
                json['m']='no'
                json['realinit']='init'
                json['options_acust']['options'][0]['show'] =true
                json['options_m']['show'] =false
                json['options_chain']['show'] =false
                json['options_acat']['show'] =true
                }
            if (gg2[0] ==='chain' &&gg2[1] !=='no'){
                json['acust']='chain'
                json['realinit']='init'
                json['options_m']['show'] =true
                json['options_acust']['options'][0]['show'] =true
                
                }
        
        }
        
    }
    const all_cfg = ['rs', 'd', 'cl', 'bl', 'i', 'sc', 'f', 'c',
        's1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10',
        'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10',
    ]
    for (let i in all_cfg) {
        let val = all_cfg[i]
        if (cfgDic.hasOwnProperty(val)) json[val] = cfgDic[val]
    }

    if (cfgDic.hasOwnProperty('m')) {
        switch (cfgDic['m']) {
            case '10-w':
                json['m'] = 'g10w'
                break;
            case '10-y':
                json['m'] = 'g10y'
                break;
            case '10-r':
                json['m'] = 'g10r'
                break;
            case '14-w':
                json['m'] = 'g14w'
                break;
            case '14-y':
                json['m'] = 'g14y'
                break;
            case '14-r':
                json['m'] = 'g14r'
                break;
            case '18-w':
                    json['m'] = 'g18w'
                    break;
            case '18-y':
                    json['m'] = 'g18y'
                    break;
            case '18-r':
                    json['m'] = 'g18r'
                   break;    

            default:
                json['m'] = cfgDic['m']

                break;
        }
    }
   // console.log('init from cfg',json)
    return json
}


class App extends Component {
//    constructor() {
//        super();
//    }
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            height: document.documentElement.clientHeight,
            width: document.documentElement.clientWidth,
//    width: window.innerWidth,
            //layout: <div/>
        };
        this.updateDimensions = this.updateDimensions.bind(this);
        //this.props.onUpdate('site',window.currentSite)
        //console.log('constructor APP', window.currentSite)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        var w = document.documentElement.clientWidth
        var h = document.documentElement.clientHeight
        this.setState({
            height: h,
            width: w
        });
    }

    componentWillReceiveProps(nextProps) {
        //console.log('App will receive Props2', this.props.push_message,nextProps)
        // console.log('will update App', window.innerWidth, 'x', window.innerHeight)
    //    if (this.messages !== undefined && this.props.push_message !== undefined) {
      if (this.messages !== undefined  && nextProps.push_message !== undefined && nextProps.push_message !== '') {
       //         console.log('App will receive Props3', this.props.push_message.detail)
          //  console.log('App will receive nextProps3',  nextProps.push_message,'end')
               this.growl.show({
                severity: nextProps.push_message.severity,
                summary: nextProps.push_message.summary,
                sticky: nextProps.push_message.sticky === true ? true : false,
                detail: nextProps.push_message.detail,
                life:'3000'
            });
         //   this.props.onRemoveMessage()
        }


    }
    
    
    componentDidMount() {
        
        

        window.addEventListener("resize", this.updateDimensions);
        //window.addEventListener("resize", this.handleResize);
        //console.log('handleResize did mount')

        let mode = 'sku'
        let header = new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data'
        });
        let sentData = {
            method: 'GET', //opt.method,
            mode: 'cors',
            header: header,

            //    body:opt.body || ''
        };
        
        var json4site ='in'
        
       // console.log('json4site',this.props,json4site,window.currentSite)
        let params = '?site='
        if (this.props.zsku !== DEFAULT_STATE_VALUE && this.props.zsku !== undefined  && this.props.cat_s ==='') {
            params += json4site + 'sku4&s=' + this.props.zsku
        }
        else if (this.props.cfg !== DEFAULT_STATE_VALUE && this.props.cfg !== undefined) {
            params = '?cfg=' + this.props.cfg
            mode = 'cfg'
        }
        else if (this.props.test=== 'yes' && this.props.s !== DEFAULT_STATE_VALUE && this.props.s !== undefined) {
           // console.log('json4site2',this.props.cat_s,json4site,window.currentSite)
            if (this.props.cat_s ==='' )
            params += 'test-in4&s=' + this.props.s
            else
            params += 'test-'+json4site + '4&s=9000' 
            
        }
        else if (this.props.s !== DEFAULT_STATE_VALUE && this.props.s !== undefined) {
            if (this.props.cat_s ==='' )
            params += 'in4&s=' + this.props.s
            else
            params += json4site + '4&s=9000'
            
        }
        else {
            this.messages.show({
                severity: 'error',
                sticky: true,
                summary: 'Site error: ',
                detail: MSG_NO_SKU
            });
            this.setState({error: true})
            return
        }
        // process if both absent
 


        let fetchUrl =JSON_URL
        if (window.currentEnv ==='www'){
            fetchUrl =JSON_URL_PROD
        }
//console.log('params',fetchUrl,params,this.props.s)
  
        fetch(fetchUrl + params, sentData)
            .then(response => {
                if (response.ok) {

                    return response.json();
                }
                else {
                    this.setState({error: true})
                    this.messages.show({
                        severity: 'error',
                        sticky: true,
                        summary: 'Site error: ',
                        detail: MSG_NO_SKU
                    });
                    throw new Error('Something went wrong ...');
                }
            })
            .then(json => {

                if (Object.keys(json).length === 0) {
                    this.setState({error: true})
                    this.messages.show({
                        severity: 'error',
                        sticky: true,
                        summary: 'Site error: ',
                        detail: MSG_NO_SKU
                    });
                    //throw new Error('Something went wrong ...');
                }
                //console.log('load json', json)
                document.title=json['title']
   //             console.log('json',json)
                if (json.hasOwnProperty('style')) {
                    var style = json['style']
                    json['cfg1'] = style    
                    json['cat_s'] = this.props.cat_s
                    json['s'] = this.props.s
                    if (this.props.cat_s !== '' ){
                        if (this.props.cat_s !== '-' ){
                        json['realinit'] = 'init'    
                        json['s'] = '9000'
                        json['style'] = '9000'
                        json['sku'] = '9000'
                        json['chain'] = 'no'
                        json['m'] = 'no'
                        json['cat_s'] = this.props.cat_s
                        if (this.props.cat_s !== '0'){
                            json['acharm'] = this.props.sku_s
                            json['acat'] = this.props.cat_s
                            }
                         }
                       
                        if (this.props.cat_s === '0'){
                            json['chain'] = '9300'
                            json['m'] = 's'
                            
                        }
                    //    json['am'] = 's'
                        
                    }
                    //    json['cfg1'] = DEFAULT_CFG.substr(0, DEFAULT_.length - style.length) + style
                    json['showReview'] = false
                }
                if (mode === 'cfg') {
                    //console.log('process',json,'end',state.cfg,'end2')
                    json = processCfg(json)
                    //console.log('after json cfg', json)
                    //json['cfg1'] = this.props.cfg
                    //json['cfg1'] = this.props.zsku
                    json['showReview'] = true
                }
              
                if (this.props.zsku !== DEFAULT_STATE_VALUE)
                    json['cfg1'] = this.props.zsku    
                json['loading'] = 'new'
                //console.log('init event',mode,json['style'])
                ReactGA.event({
                    category: 'init-' +mode,
                    action:'init-' +mode
                });
          //      console.log( 'yes',json['lifestyle'])
                if (json['lifestyle'] === 'yes')
                {
            //       console.log( 'yes')
                    
                ReactGA.event({
                    category: 'lifestyle',
                    action:'lifestyle'
                });
            }

//      var json2 =  Object.assign({}, json);
                var json2 = JSON.parse(JSON.stringify(json));
                json.start_over_init = json2

               //console.log('json.showReview2', json.showReview)


               //console.log('FROM JSON INIT ARRAY',  json2)
               //console.log('FROM JSON INIT ARRAY', this.props.initAttr, this.props.initValue)
               json['currentSite']=window.currentSite
       
                
               this.props.onJson(json);
                if (this.props.initAttr !== false)
                    this.props.onLoad(this.props.initAttr, this.props.initValue)
                this.props.onImage(1)

                //this.props.onLoad('loading','new')
               // console.log('LOADING NEW', this.props.loading)

            })
            
            // .catch(errorMsg => {
            //     //error = true
            //     this.messages.show({
            //         severity: 'error',
            //         sticky: true,
            //         summary: 'Error loading item info: ',
            //         detail: 'Cannot initialize data'
            //     });
            //     console.log('error', errorMsg)
            // });
         

    }

    render() {


        var layout;
        //console.log('on render App', this.props.push_message)
        var layoutDataP = [
            {
                size: 350,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 2,
                optionSize: 'small'
            },
            {
                size: 500,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'small',
                optionNumber: 3,
                optionSize: 'small'
            },
            {
                size: 600,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 4,
                optionSize: 'small'
            },
            {
                size: 720,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 4,
                optionSize: 'small'
            },
            {
                size: 820,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 5,
                optionSize: 'small'
            },
            {
                size: 900,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 6,
                optionSize: 'small'
            },
            {
                size: 1000,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 7,
                optionSize: 'small'
            },
            {
                size: 1150,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 8,
                optionSize: 'small'
            },
            {
                size: 1300,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 9,
                optionSize: 'small'
            },
            {
                size: 20000,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 10,
                optionSize: 'small'
            },
        ]
        var layoutDataL = [
            {
                size: 350,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 2,
                optionSize: 'small'
            },
            {
                size: 590,
                header: 'medium',
                footer: 'medium',
                orientation: 'portrait',
                image: 'medium',
                optionNumber: 3,
                optionSize: 'small'
            },
            {
                size: 650,
                header: 'medium',
                footer: 'medium',
                orientation: 'landscape',
                image: 'medium',
                optionNumber: 3,
                optionSize: 'small'
            },
            //{size:700,header:'medium', footer:'medium', orientation:'landscape', image:'medium', optionNumber:3, optionSize:'small'},
            {
                size: 760,
                header: 'medium',
                footer: 'medium',
                orientation: 'landscape',
                image: 'medium',
                optionNumber: 3,
                optionSize: 'small'
            },
            {
                size: 1000,
                header: 'medium',
                footer: 'medium',
                orientation: 'landscape',
                image: 'medium',
                optionNumber: 3,
                optionSize: 'small'
            },
            {
                size: 1200,
                header: 'medium',
                footer: 'medium',
                orientation: 'landscape',
                image: 'big',
                optionNumber: 4,
                optionSize: 'small'
            },
            {
                size: 1400,
                header: 'medium',
                footer: 'medium',
                orientation: 'landscape',
                image: 'big',
                optionNumber: 6,
                optionSize: 'small'
            },
            {
                size: 20000,
                header: 'big',
                footer: 'big',
                orientation: 'landscape',
                image: 'big',
                optionNumber: 7,
                optionSize: 'small'
            },
        ]
      
        if (this.state.error === false && this.props.json !== undefined) {
            var i;
            let w = this.state.width
            let h = this.state.height
            // let w = window.innerWidth
            // let h = window.innerHeight
            if (w < h) {
                for (i in layoutDataP) {
                    if (w <= layoutDataP[i].size) {
      //                  console.log('APP -> windows size h x w',layoutDataP[i].optionSize)
                        layout = <AiLayout header={layoutDataP[i].header} footer={layoutDataP[i].footer}
                                           orientation={layoutDataP[i].orientation}
                                           image={layoutDataP[i].image} optionNumber={layoutDataP[i].optionNumber}
                                           optionSize={layoutDataP[i].optionSize}
                                           messages={this.messages}
                        />
                        break
                    }

                }
            }
            else {
                for (i in layoutDataL) {
                    if (w <= layoutDataL[i].size) {
                        layout = <AiLayout header={layoutDataL[i].header} footer={layoutDataL[i].footer}
                                           orientation={layoutDataL[i].orientation}
                                           image={layoutDataL[i].image} optionNumber={layoutDataL[i].optionNumber}
                                           optionSize={layoutDataL[i].optionSize}
                                           messages={this.messages}
                        />
                        break
                    }

                }
            }
        }
        /*
        document.on("click",".horizontal-menu-container .nav-toggle",function() {
            document.getElementsByName(".nav-horizontal").addClass("nav-before-open nav-open");
        });
        
        this.on("click",".close-menu",function() {
            $(".nav-horizontal").removeClass("nav-before-open nav-open");
        });
        this.body.on('click', '.horizontal-list li.ui-menu-item .open-children-toggle', function(){
            if(!$(this).parent().hasClass("opened-is")) {
                $(this).parent().addClass("opened-is");
            } else {
                $(this).parent().removeClass("opened-is");
            }
        });
        $('body').on('click', '.horizontal-list li.ui-menu-item .back-main-menu', function(){
            $(this).closest('li.ui-menu-item').removeClass("opened-is");
        });
        $('body').on('click', '.horizontal-list .close-main-menu', function(){
            if($("html").hasClass("nav-open")) {
                $("html").removeClass("nav-open");
                $("html").removeClass("nav-before-open");
                $("li.ui-menu-item").removeClass("opened-is");
            }
            return false;
        });
         */


        if (this.state.error)
            layout = <AiLayout header='medium' footer='medium' orientation='error'/>
        return (

            <div className='ai-container'>
                <Growl ref={(el) => this.growl = el} position='bottomleft' baseZIndex={40000}/>
                <Messages
                    //style={{ margin: 'auto', position: 'absolute', zIndex: 20000, top: '0', left: '0', bottom: '0', right: '0'}}
                    ref={(el) => this.messages = el}></Messages>

                {layout}
                {/*<div style={{float:'right'}} >windows  w x h={this.state.width}x{this.state.height}
     <br/> document w x h={document.documentElement.clientWidth+'x'+document.documentElement.clientHeight}
     <br/> body w x h={document.documentElement.getElementsByTagName('body')[0].clientWidth+'x'+document.documentElement.getElementsByTagName('body')[0].clientHeight}
  

  </div>*/}
  
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js